const getBuildUP = (chg, oiChg) => {
    let bu = "";

    if (chg > 0 && oiChg > 0) {
        bu = 'LB';
    } else if (chg < 0 && oiChg > 0) {
        bu = 'SB';
    } else if (chg > 0 && oiChg < 0) {
        bu = 'SC';
    } else if (chg < 0 && oiChg < 0) {
        bu = 'LU';
    }
    return bu;
}

export const getFullStrikeStocksStrangle = (ceData, peData, ceSym, peSym, strikeCE, strikePE, prevData) => {

    let pData = {ce:prevData[strikeCE].ce, pe:prevData[strikePE].pe};
    let ceSymData = getStock(ceSym, 'ce', pData);
    let peSymData = getStock(peSym, 'pe', pData);
    let straddleData = getStraddle(ceSymData, peSymData);
  
    return {
        'CE': ceData.CE,
        'exchangeToken-CE': ceData['exchangeToken-CE'],
        'tradingSymbol-CE': ceData['tradingSymbol-CE'],
        'exchange-CE': ceData['exchange-CE'],
        'lotSize-CE': ceData['lotSize-CE'],
        'displayName-CE': ceData['displayName-CE'],
        'strike-CE': ceData['strike-CE'],

        'PE': peData.PE,
        'exchangeToken-PE': peData['exchangeToken-PE'],
        'tradingSymbol-PE': peData['tradingSymbol-PE'],
        'exchange-PE': peData['exchange-PE'],
        'lotSize-PE': peData['lotSize-PE'],
        'displayName-PE': peData['displayName-PE'],
        'strike-PE': peData['strike-PE'],

        ...ceSymData,
        ...peSymData,
        ...straddleData,
        strikeCE: strikeCE,
        strikePE: strikePE
    }
};


export const getFullStrikeStocks = (ceSym, peSym, strike, prevData) => {
    let ceSymData = getStock(ceSym, 'ce', prevData);
    let peSymData = getStock(peSym, 'pe', prevData);
    let straddleData = getStraddle(ceSymData, peSymData);

    return {
        ...ceSymData,
        ...peSymData,
        ...straddleData,
        strike: strike
    }
};

export const getStock = (sym, type , prevData) => {
     
    let prevDO = prevData[type]?.do;
    let prevLP = prevData[type]?.lp || 0;
    let prevOI = prevData[type]?.oi || 0;
    let prevIV = prevData[type]?.iv || 0;
    
    let buildUP = getBuildUP(sym?.lp - prevLP, sym?.oi - prevOI)
    if(type=="ce") {
        var trend = (buildUP === "LB" || buildUP === "SC") ? "Bullish" : (buildUP === "SB" || buildUP === "LU") ? "Bearish" : "";
     } else {
         var trend = (buildUP === "SB" || buildUP === "LU") ? "Bullish" : (buildUP === "SC" || buildUP === "LB") ? "Bearish" : "";
     }
 
    const Type = type.toUpperCase(); // "CE" or "PE"
    
    return {
        // UI Style (Lowercase prefix: ceLP, peLP)
        [type + "LP"]: sym?.lp,
        [type + "Chg"]: sym?.lp - prevLP,
        [type + "PChg"]: prevLP !== 0 ? ((100 * (sym?.lp - prevLP)) / prevLP) : '-',
        [type + "iv"]: sym?.iv,
        [type + "delta"]: sym?.d,
        [type + "Chg_open"]: sym?.lp - prevDO,
        [type + "PChg_open"]: prevDO !== 0 ? ((100 * (sym?.lp - prevDO)) / prevDO) : '-',

        // Selector Style (Suffix: lpCE, deltaCE) - Required for helper.js
        ["lp" + Type]: sym?.lp,
        ["chg" + Type]: sym?.lp - prevLP,
        ["pChg" + Type]: prevLP !== 0 ? ((100 * (sym?.lp - prevLP)) / prevLP) : null,
        ["iv" + Type]: sym?.iv,
        ["delta" + Type]: sym?.d,
        
        // Original keys for any legacy support
        ["lp" + type]: sym?.lp,
        ["chg" + type]: sym?.lp - prevLP,
        ["oi" + type]: sym?.oi,
        ["oiChg" + type]: sym?.oi - prevOI,
        ["oiPChg" + type]: prevOI !== 0 ? (100 * (sym?.oi - prevOI)) / prevOI : null,
        ["vol" + type]: sym?.vt,
        ["buildup" + type]: buildUP,
        ["trend" + type]: trend,
        ["orderflow" + type]: sym?.cdv,
        ["gamma" + type]: sym?.g,
        ["theta" + type]: sym?.t,
        ["vega" + type]: sym?.ve,
        ["bid" + type]: sym?.bid.p,
        ["ask" + type]: sym?.ask.p,
        ["atp" + type]: sym?.atp,
        ["ltpChgOpen" + type]: sym?.lp - sym?.do,
        ["ltpChgPOpen" + type]: sym?.do !== 0 ? ((100 * (sym?.lp - sym?.do)) / sym?.do) : null,
    }
};

export const getStraddle = (ceData, peData) => {
    return {
        "straddleLP" : !isNaN(ceData.ceLP) && !isNaN(peData.peLP) ? ceData.ceLP + peData.peLP : '-',
        "straddleChg" : !isNaN(ceData.ceChg) && !isNaN(peData.peChg) ? ceData.ceChg + peData.peChg : '-',
        "straddlePChg" : !isNaN(ceData.cePChg) && !isNaN(peData.pePChg) ? ceData.cePChg + peData.pePChg : '-',
        "straddleChg_open" : !isNaN(ceData.ceChg_open) && !isNaN(peData.peChg_open) ? ceData.ceChg_open + peData.peChg_open : '-',
        "straddlePChg_open" : !isNaN(ceData.cePChg_open) && !isNaN(peData.pePChg_open) ? ceData.cePChg_open + peData.pePChg_open : '-',
    }
};
